export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}

export function move(
  source,
  destination,
  droppableSource,
  droppableDestination
) {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
}

export function arr2Str(arr) {
  if (!Array.isArray(arr)) {
    return "";
  }
  let newArr = arr.sort();
  let result = "";
  for (let i = 0; i < newArr.length; i++) {
    result = result.concat(newArr[i], ", ");
  }
  return result;
}

export function objArr2Str(arr, key) {
  if (!Array.isArray(arr)) {
    return "";
  }
  let newArr = arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
  let result = "";
  for (let i = 0; i < newArr.length; i++) {
    result = result.concat(newArr[i][key], ", ");
    console.log("result", i, result, newArr[i], key, newArr[i][key]);
  }
  return result;
}

export function objArr2Arr(arr, key) {
  if (!Array.isArray(arr)) {
    return [];
  }
  let newArr = arr.sort((a, b) => {
    if (a[key] < b[key]) {
      return -1;
    }
    if (a[key] > b[key]) {
      return 1;
    }
    return 0;
  });
  console.log("newArr", newArr);
  let result = [];
  for (let i = 0; i < newArr.length; i++) {
    result.push(newArr[i][key]);
  }
  return result;
}

export function str2Arr(str) {
  if (str && typeof str === "string") {
    let strSplit = str.split(/[;,]+/);

    let trimRes = [];
    strSplit.forEach((element) => trimRes.push(element.trim()));
    for (let resI = trimRes.length - 1; resI > -1; resI--) {
      if (trimRes[resI] === "" || trimRes[resI] === ",") {
        trimRes.splice(resI, 1);
      }
    }

    let newRes = trimRes.sort();
    return newRes;
  } else {
    return [];
  }
}

export function space2Arr(str) {
  if (str && typeof str === "string") {
    let strSplit = str.split(/[;, ]+/);

    let trimRes = [];
    strSplit.forEach((element) => trimRes.push(element.trim()));

    for (let resI = trimRes.length - 1; resI > -1; resI--) {
      if (trimRes[resI] === "" || trimRes[resI] === ",") {
        trimRes.splice(resI, 1);
      }
    }

    let newRes = trimRes.sort();
    return newRes;
  } else {
    return [];
  }
}

export function stripHtml(html) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
}

export function reduceList(inputList) {
  var out = [];
  var seen = {};
  var len = inputList.length;
  var j = 0;
  for (var i = 0; i < len; i++) {
    var item = inputList[i];
    if (seen[item] !== 1) {
      seen[item] = 1;
      out[j++] = item;
    }
  }
  return out;
}
export function reduceListObj(inputList, key) {
  var out = [];
  var seen = {};
  var len = inputList.length;
  var j = 0;
  for (var i = 0; i < len; i++) {
    var itemObj = inputList[i];
    if (seen[itemObj[key]] !== 1) {
      seen[itemObj[key]] = 1;
      out[j++] = itemObj;
    }
  }
  return out;
}

export function sortObjArr(inputArr, property) {
  inputArr.sort((a, b) =>
    a[property] > b[property] ? 1 : a[property] == b[property] ? 0 : -1
  );
  //we need < for gantt column order
  return inputArr;
}

export function sortObjArrTime(inputArr, property) {
  inputArr.sort((a, b) =>
    new Date(a[property]).getTime() > new Date(b[property]).getTime()
      ? 1
      : b[property] == a[property]
      ? 0
      : -1
  );
  return inputArr;
}

export function sortObjArrTrueFalse(inputArr, property) {
  let outputArr = inputArr.sort((a, b) =>
    a[property] > b[property] ? 1 : a[property] == b[property] ? 0 : -1
  );
  return outputArr;
}

export function perc2color(perc) {
  var r,
    g,
    b = 0;
  if (perc < 50) {
    g = 255;
    r = Math.round(5.1 * perc);
  } else if (perc < 100) {
    r = 255;
    g = Math.round(510 - 5.1 * perc);
  } else {
    g = 0;
    r = 255;
  }
  var h = r * 0x10000 + g * 0x100 + b * 0x1;
  return "#" + ("000000" + h.toString(16)).slice(-6) + "aa";
}

export function debounce(func, timeout) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function convertDate2LocDate(standardDate, dateFormat) {
  let locDate = new Date();
  if (standardDate !== "" && standardDate) {
    locDate = standardDate;
    let dateArr = locDate.split("-");
    if (dateFormat === "DD-MM-YYYY") {
      locDate = `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
    } else if (dateFormat === "MM-DD-YYYY") {
      locDate = `${dateArr[1]}-${dateArr[2]}-${dateArr[0]}`;
    }
  }

  return locDate;
}

export function getLocalTimestamp() {
  const now = new Date();

  const pad = (n) => String(n).padStart(2, "0");

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1); // months are 0-based
  const day = pad(now.getDate());

  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());
  const seconds = pad(now.getSeconds());

  return `${year}-${month}-${day} ${hours}-${minutes}-${seconds}`;
}

export function parseDateToUTC(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)); // month is 0-based
}
